// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Animations */
@keyframes fade-in {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in {
    animation: fade-in 1s ease-out;
}

/* Smooth Scrolling */
html {
    scroll-behavior: smooth;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
    width: 12px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
    background: #dc2626;
    border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
    background: #b91c1c;
}

/* Hide scrollbar for Chrome, Edge, Safari */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for Firefox */
.scrollbar-hide {
  scrollbar-width: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA,qBAAqB;AACrB;IACI,uBAAuB;AAC3B;;AAEA,qBAAqB;AACrB;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;AACf;AACA,+BAA+B;AAC/B;EACE,qBAAqB;AACvB","sourcesContent":["/* Custom Animations */\n@keyframes fade-in {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.animate-fade-in {\n    animation: fade-in 1s ease-out;\n}\n\n/* Smooth Scrolling */\nhtml {\n    scroll-behavior: smooth;\n}\n\n/* Custom Scrollbar */\n::-webkit-scrollbar {\n    width: 12px;\n}\n\n::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #dc2626;\n    border-radius: 6px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #b91c1c;\n}\n\n/* Hide scrollbar for Chrome, Edge, Safari */\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n/* Hide scrollbar for Firefox */\n.scrollbar-hide {\n  scrollbar-width: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
